import { render } from "./CustomerViewCustomerChannels.vue?vue&type=template&id=56c71cd0&scoped=true"
import script from "./CustomerViewCustomerChannels.vue?vue&type=script&lang=js"
export * from "./CustomerViewCustomerChannels.vue?vue&type=script&lang=js"

import "./CustomerViewCustomerChannels.vue?vue&type=style&index=0&id=56c71cd0&lang=scss&scoped=true"
import "./CustomerViewCustomerChannels.vue?vue&type=style&index=1&id=56c71cd0&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c71cd0"]])

export default __exports__